import { useEffect, useState } from 'react'
import './productListing.css'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { auth } from '../config/firebase'
import { signOut } from 'firebase/auth'

export default function TestListing(){
    const navigate = useNavigate()
    useEffect(()=>{        
        if(sessionStorage.getItem('login')!='true'){
            navigate('/admin/login')
        }
    },[])

    const [tests, setTests]=useState([])

    useEffect(()=>{
        const fetchCount = async()=>{
            try{
                const response = await axios.get(`${process.env.React_APP_API_URL}/api/v1/testimonial`);
                if(response.status===200){
                    setTests(response.data)
                }
            }catch(err) {
                console.log(err)
            }
        }

        fetchCount()
    },[])

    const [loadingest, setLoadingest] = useState(false)
    const delprod = (e,product) =>{
        e.preventDefault()
        setLoadingest(true)

        axios.delete(`${process.env.React_APP_API_URL}/api/v1/testimonial/${product.id}`, { 
            data:{
                id:product.id,
                image:product.testimage,                
            }})
        .then(res=>{
            setLoadingest(false) 
            if(res.status===200){
                window.location.reload();
            }
        })
    }
    return(
        <>
        <div className='listingWrapper'>
            <div className='CMSLable'>
                <h3>Hi,</h3>
                <div className='CMSLableBtn'>
                    <button onClick={()=>(signOut(auth),sessionStorage.setItem('login','false'), window.location.reload())}>Log Out</button>
                    <button onClick={()=>navigate('/')}>Go To Site</button>
                </div>                
            </div>
            <div className='CMSHeader'>
                <h2>Testimonials</h2>
                <div className='CMSnavBTN'>
                    <Link to={'/admin/testForm'}><button>Add Testimonial</button></Link>
                    <Link to={'/admin/dashboard'}><button>Dashboard</button></Link>
                </div>
            </div>
            <div className='listContainer'>
                <table>
                    <thead>
                    <tr
                    >
                        <th style={{width:"10rem"}}>Name</th>
                        <th style={{width:"10rem"}}>Title</th>
                        <th style={{width:"5rem"}}>Rating</th>
                        <th style={{width:".25rem", backgroundColor:"transparent", border:"none"}}></th>
                        <th colSpan={1} style={{width:"4rem", border:"none", textAlign:"center"}}>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style={{height:".25rem"}}></tr>
                    {
                        tests.map((test,key)=>(
                            <>
                            <tr key={key}>
                                <td>{test.testname}</td>
                                <td>{test.testtitle}</td>
                                <td>{test.testrating}</td>
                                <td style={{border:"none"}}></td>
                                {/* <td className='listBNT' style={{border:"none",textAlign:"center"}}>
                                    <div><Link to='/admin/testForm' state={{testData:test}}>Edit</Link></div>
                                </td> */}
                                <td className='listBNT delBtn' style={{border:"none",textAlign:"center"}} onClick={(e)=>delprod(e,test)}><div>Delete</div></td>
                            </tr>
                            <tr style={{height:".25rem"}}></tr>
                            </>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </div>
            <div className={loadingest?'estloadingContainer showFlex':'estloadingContainer hide'}>
            <div className='estloadingBG'></div>
            <div className='estloading'>
                <img src='../images/loading.png' />
            </div>
        </div>
        </>
)
}